import './bootstrap';

require('./scripts/modules/invoices/main');
